import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TipoRecurso } from '../models/notice.model';

@Injectable({
  providedIn: 'root'
})
export class TipoRecursoService {
  private apiUrl = `${environment.apiUrl}/admin/tipos-recursos`;

  constructor(private http: HttpClient) {}

  getAll(apenasAtivos: boolean = false): Observable<TipoRecurso[]> {
    let params = new HttpParams();
    if (apenasAtivos) {
      params = params.set('apenasAtivos', 'true');
    }
    return this.http.get<TipoRecurso[]>(this.apiUrl, { params });
  }

  getById(id: number): Observable<TipoRecurso> {
    return this.http.get<TipoRecurso>(`${this.apiUrl}/${id}`);
  }

  create(resourceType: TipoRecurso): Observable<TipoRecurso> {
    return this.http.post<TipoRecurso>(this.apiUrl, resourceType);
  }

  update(id: number, resourceType: TipoRecurso): Observable<TipoRecurso> {
    return this.http.put<TipoRecurso>(`${this.apiUrl}/${id}`, resourceType);
  }
  
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  toggleStatus(id: number, ativo: boolean): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/toggle-status`, { ativo });
  }
}